export default __webpack_public_path__ + "static/media/arrow.437c30cf.svg";